import { SignupAttribution } from '../types';

const SESSION_TOKEN_KEY = 'bhi.signup.token';

export const SIGNUP_SESSION_HEADER = 'x-signup-token';

export const getSignupToken = (): string | null => localStorage.getItem(SESSION_TOKEN_KEY);

export const setSignupToken = (token: string): void => localStorage.setItem(SESSION_TOKEN_KEY, token);

export const clearSignupToken = (): void => localStorage.removeItem(SESSION_TOKEN_KEY);

/**
 * Read once on the first screen: by the time the funnel is submitted the visitor may have navigated within
 * the app, and the campaign parameters would be gone from the address bar.
 */
export const collectAttribution = (): SignupAttribution => {
  const params = new URLSearchParams(window.location.search);

  return {
    utmSource: read(params, 'utm_source'),
    utmMedium: read(params, 'utm_medium'),
    utmCampaign: read(params, 'utm_campaign'),
    utmTerm: read(params, 'utm_term'),
    utmContent: read(params, 'utm_content'),
    referrer: document.referrer || null,
    landing: window.location.pathname || null,
  };
};

const read = (params: URLSearchParams, key: string): string | null => {
  const value = params.get(key);
  return value != null && value.length > 0 ? value : null;
};
